import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './Assets/App.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import Layout from './Components/Layout';
import Home from './Pages/Home'; // Assuming you have an IntroPage component
import VideoGallery from './Pages/Gallery';
import Donation from './Pages/Donate';
import NotFound from "./Pages/NotFound"; // 404 page
import Chatbot from './Pages/ChatbotForm';
import Participants from './Pages/Participants';

const MainApp = () => {
  
  return (
    <Router>
      <Routes>
        {<Route path="/" element={<Layout><Home /></Layout>}/>}
        {<Route path="/news-and-media" element={<Layout><VideoGallery /></Layout>}/>}
        {<Route path="/donate" element={<Layout><Donation /></Layout>}/>}
        {<Route path="/join-movement" element={<Layout><Chatbot /></Layout>}/>}
        {<Route path="/participants" element={<Layout><Participants /></Layout>}/>}

        {/* Catch-all route for 404 */}
        {<Route path="*" element={<NotFound />} />}
      </Routes>
    </Router>
  );
}

export default MainApp;
